var _rect, _rect2, _rect3, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillManycashYlLg = function SvgFillManycashYlLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 100,
    fill: "none",
    viewBox: "0 0 101 100"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.167,
    height: 45.833,
    x: 10.917,
    y: 32.293,
    fill: "#F8C200",
    rx: 8.333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 79.167,
    height: 45.833,
    x: 10.917,
    y: 21.875,
    fill: "#FFE357",
    rx: 8.333
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 70.833,
    height: 37.5,
    x: 15.084,
    y: 26.043,
    fill: "#FFD70F",
    rx: 6.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDF8D5",
    d: "M32.792 21.875h35.417v45.833H32.792z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEEA87",
    d: "M32.792 67.707h35.417v10.417H32.792z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8A300",
    d: "m60.28 40.597.742-2.565a.417.417 0 0 0-.4-.532h-3a.42.42 0 0 0-.405.323l-2.37 10.253-2.623-10.263a.42.42 0 0 0-.404-.313h-2.64a.42.42 0 0 0-.404.313L46.14 48.076l-2.357-10.253a.42.42 0 0 0-.406-.323H40.38a.417.417 0 0 0-.4.532l.742 2.565h-3.346a.417.417 0 0 0-.416.416v2.63c0 .23.186.417.416.417h4.337l2.494 8.69a.42.42 0 0 0 .4.302h2.756a.42.42 0 0 0 .4-.3l2.738-9.425 2.738 9.424c.052.178.215.3.4.3h2.769c.186 0 .35-.123.4-.301l2.481-8.69h4.337c.23 0 .417-.186.417-.416v-2.63a.417.417 0 0 0-.417-.417z"
  })));
};
export default SvgFillManycashYlLg;